import { query_card_list } from '@/api/mjstore-model';
import { reactive } from 'vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import defaultSlotList from '@/components/page-model/slotList';
import { TableColumn } from '@/typing';
import { SearchConfig } from '@/components/FormRender/RemoteModal/typing';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const config: SearchConfig = {
  settings: {
    name: '表单名称',
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '卡编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写卡编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '卡名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写卡名称',
    },
    {
      type: 'remoteselect',
      name: 'project_type_id',
      label: '项目分类',
      disabled: false,
      placeholder: '请选择项目分类',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-projecttype',
    },
    {},
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    code: null,
    project_type_id: null,
    card_type: null,
    is_any_project: null,
  }),
};
const search_options = {
  card_type: [
    { value: None, name: '全部' },
    { value: 1, name: '次卡' },
    { value: 11, name: '时间卡' },
    { value: 21, name: '产品卡' },
    { value: 31, name: '二次卡' },
  ],
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const columns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: '项目ID',
    width: 150,
    dataIndex: 'id',
    checked: false,
  },
  {
    title: '卡编号',
    width: 150,
    dataIndex: 'code',
    checked: true,
  },
  {
    title: '卡名称',
    width: 150,
    dataIndex: 'name',
    checked: true,
  },
  {
    title: '单价',
    width: 150,
    dataIndex: 'price',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '最大使用次数',
    width: 150,
    dataIndex: 'max_num',
    checked: true,
  },
  {
    title: '月数',
    width: 150,
    dataIndex: 'month_num',
    checked: true,
  },
  {
    title: '卡类型',
    width: 150,
    dataIndex: 'card_type',
    checked: true,
  },
  {
    title: '任意项目可做',
    width: 150,
    dataIndex: 'is_any_project',
    checked: true,
  },
  {
    title: '项目分类ID',
    width: 150,
    dataIndex: 'project_type_id',
    checked: false,
  },
  {
    title: '项目分类',
    width: 150,
    dataIndex: 'project_type__name',
    checked: true,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    checked: true,
  },
  {
    title: '更新时间',
    width: 150,
    dataIndex: 'update_time',
    checked: true,
  },
  {
    title: '是否可用',
    width: 150,
    dataIndex: 'is_active',
    checked: true,
  },
];

export default () => {
  return {
    searchConfig: config,
    searchConfigOptions: search_options,
    getData: query_card_list,
    columns: columns,
    slotList: defaultSlotList,
  };
};
